export default {
  animated: true,
  view: {
    styles: {
      background: '#1a1e30',
    },
  },
  data: {
    hover: {
      enable: true
    }
  },
  tooltip: {
    enable: true,
    styles: {
      color: '#ffffff',
      background: '#403f4c',
      borderColor: '#fff',
      borderWidth: 0,
      borderRadius: 3,
      fontSize: 12,
      padding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10,
      },
    },
  },
};
